import { Link, usePage } from "@inertiajs/react"
import { Button } from "@/components/ui/button"
import AppearanceToggleDropdown from "@/components/appearance-dropdown"
import { signInPath, signUpPath } from "@/routes"
import { usePrefetchLink } from "@/hooks/use-prefetch-link"

export function MarketingNav() {
  const page = usePage()
  const { auth } = page.props
  const signInPrefetch = usePrefetchLink(signInPath())
  const signUpPrefetch = usePrefetchLink(signUpPath())
  const dashboardPrefetch = usePrefetchLink("/dashboard")

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-200 bg-white/95 backdrop-blur-md dark:border-slate-800 dark:bg-slate-950/95">
      <div className="container mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <Link
            href="/"
            className="text-xl font-bold text-indigo-600 dark:text-indigo-400"
          >
            {import.meta.env.VITE_APP_NAME ?? "ThaiCopilot"}
          </Link>
          <div className="flex items-center gap-3">
            <AppearanceToggleDropdown />
            {auth.user ? (
              <div className="flex items-center gap-2">
                <Button asChild size="sm">
                  <Link href="/dashboard" {...dashboardPrefetch}>
                    Dashboard
                  </Link>
                </Button>
              </div>
            ) : (
              <>
                <Button asChild variant="ghost" size="sm">
                  <Link href={signInPath()} {...signInPrefetch}>
                    Log in
                  </Link>
                </Button>
                <Button asChild size="sm">
                  <Link href={signUpPath()} {...signUpPrefetch}>
                    Sign up
                  </Link>
                </Button>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  )
}
